// product-catalog.component.ts
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MedicoService, Product } from './../../shared/servicio/medico/medico.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-catalogo',
  templateUrl: './catalogo.component.html',
  styleUrls: ['./catalogo.component.css']
})
export class CatalogoComponent implements OnInit {
  products: Product[] = [];
  filterForm: FormGroup;
  currentPage = 1;
  totalPages = 0;
  totalItems = 0;
  isLoading = false;


  constructor(
    private productService: MedicoService,
    private fb: FormBuilder
  ) {
    this.filterForm = this.fb.group({
      name: [''],
      maker: [''],
      product_id: ['']
    });
  }

  redirectToProduct(product: any): void {
    const win = window.open('about:blank', '_blank');
    if (win) {
      const url = `https://tudrogueriavirtual.com/${product.link_id}/p`;
      win.location.href = url;
    }
  }



  ngOnInit(): void {
    // Apply filters when form values change
    this.filterForm.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged((prev, curr) =>
        prev.name === curr.name &&
        prev.maker === curr.maker &&
        prev.product_id === curr.product_id
      )
    ).subscribe(() => {
      this.currentPage = 1;
      this.loadProducts();
    });

    // Initial load
    this.loadProducts();
  }

  loadProducts(): void {
    this.isLoading = true;

    const filters = {
      ...this.filterForm.value,
      page: this.currentPage
    };

    this.productService.getProducts(filters).subscribe({
      next: (response: any) => {
        const res = response.response; // <- acceso correcto

        this.products = res.data || [];
        this.totalItems = res.total || 0;
        this.totalPages = Math.ceil((res.total || 0) / (res.per_page || 10));
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading products', error);
        this.isLoading = false;
      }
    });
  }


  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadProducts();
  }



  applyFilters(): void {
    this.currentPage = 1;
    this.loadProducts();
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.loadProducts();
    }
  }

  // Helper methods for pagination
  get pages(): number[] {
    const range = 2; // Show 2 pages before and after current page
    const startPage = Math.max(1, this.currentPage - range);
    const endPage = Math.min(this.totalPages, this.currentPage + range);

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }
}
